import {
  Component,
  ChangeDetectionStrategy,
  Input,
  HostBinding,
  OnChanges,
  SimpleChanges,
  ViewChild,
  OnDestroy,
} from '@angular/core';
import { NgxDeepEqualsPureService } from 'ngx-deep-equals-pure';
import { PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { Subject } from 'rxjs';
import { delay } from 'rxjs/operators';
import { SubSink } from 'subsink';
import { ChatMessage } from '../models';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ChatService } from '../services';
import { AuthService, Unity4Claim } from '../../auth/';
@Component({
  selector: 'lib-chat-pinned-message',
  templateUrl: './chat-pinned-message.component.html',
  styles: [
    `
      .chat-messages {
        border-right: 1px solid #67757c;
        //max-height: 6em;
      }

      .chat-scroll {
        overflow: auto;
        padding-left: 5px;
        padding-right: 10px;
      }

      .small-avatar {
        min-width: 31px;
        max-width: 31px;
        min-height: 31px;
        max-height: 31px;
        overflow: hidden;
      }

      .border-8 {
        border-radius: 8px !important;
      }

      .extra-small {
        font-size: 60%;
      }

      .ml-31 {
        margin-left: 31px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatPinnedMessageComponent implements OnChanges, OnDestroy {
  @HostBinding('class') class = 'd-flex flex-column';
  @Input() currentUserId?: number;
  @Input() messages?: ChatMessage[];
  @ViewChild(PerfectScrollbarDirective, { static: false })
  scrollBar?: PerfectScrollbarDirective;
  @Input() showGroup: boolean = false;
  @Input() showSettings: boolean = false;

  private currentTip?: NgbTooltip;
  private scrollToBottom = new Subject<void>();
  private subs = new SubSink();

  activeRoom: string = '';
  autoScroll: boolean = true;
  showToolTip$ = this.authSvc.hasClaim$(Unity4Claim.ChatSupervisor);

  constructor(
    private deepEqualsSvc: NgxDeepEqualsPureService,
    private chatSvc: ChatService,
    private authSvc: AuthService
  ) {
    this.subs.sink = this.scrollToBottom.pipe(delay(100)).subscribe(() => {
      this.scrollBar?.update();
      if (this.autoScroll) {
        this.scrollBar?.scrollToBottom();
      }
    });

    this.chatSvc.activeRoom$.subscribe((room) => {
      this.activeRoom = room ? room : '';
    });
  }

  messageById(index: number, item: ChatMessage) {
    return item.messageId;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.messages &&
      (changes.messages.firstChange ||
        !this.deepEqualsSvc.deepEquals(
          changes.messages.previousValue,
          changes.messages.currentValue
        ))
    ) {
      this.scrollToBottom.next();
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  showTip(tip: NgbTooltip) {
    if (this.currentTip && this.currentTip !== tip) {
      this.currentTip?.close();
    }
    this.currentTip = tip;
    tip.open();
  }

  startAutoScroll(event: any) {
    this.autoScroll = true;
    this.currentTip?.close();
  }

  stopAutoScroll(event: any) {
    if (this.scrollBar?.ps()?.reach.y !== 'end') {
      this.autoScroll = false;
    }
    this.currentTip?.close();
  }

  unpin(messageId: number, tip: NgbTooltip) {
    this.currentTip = undefined;
    this.chatSvc.unpinMessage(messageId);
    tip.close();
  }
}
